import { AuthenticationService } from "src/app/core/services/authentication.service";
import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Router } from "@angular/router";

import { CompanyService } from "~/core/services/company.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  company;
  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private companyService: CompanyService,
  ) {
    this.company = this.companyService.getCurrentCompany();
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const skip = request.headers.has("skipInterceptor");
    const headers = skip
      ? request.headers.delete("skipInterceptor")
      : request.headers;
    return next.handle(request.clone({ headers })).pipe(
      tap(
        (ev: HttpEvent<any>) => {
          if (ev instanceof HttpResponse) {
          }
        },
        (error: any) => {
          if (error instanceof HttpErrorResponse) {
            if (
              error.status === 401 &&
              error.error === "Unauthorized" &&
              !skip &&
              request.url.includes(environment.backEndUrl)
            ) {
              console.log("Unauthorized by:", request);
              this.auth.setCurrentUser(null);
              this.router.navigate([`/admin`]);
            }
          }
        },
      ),
    );
  }
}
